import React, { useEffect, useMemo, useState } from 'react'
import TreeAPI from '../../apis/TreeAPI';
import produce from 'immer';
import { useCourses } from './useCourses';

const useEpisodes = (props: IUseEpisodesProps) => {
    const { courses } = useCourses();
    const [episodes, setEpisodes] = useState<{
        [key: string]: IDBRealtimeEpisode | undefined;
    }>({});

    useEffect(() => {
        setEpisodes({});
        const unsubscribe = TreeAPI.subscribeToEpisodes(
            (episode: IDBRealtimeEpisode) => {
                setEpisodes(
                    produce(draft => {
                        draft[episode.id] = episode;
                    })
                );
            },
            (id: string) => {
                setEpisodes(
                    produce(draft => {
                        draft[id] = undefined;
                    })
                );
            }
        );
        return () => unsubscribe();
    }, []);

    const episodesObj = useMemo(() => {
        let result: typeof episodes = {};
        
        if(props.courseId === undefined) return {};

        const courseObj = courses[props.courseId];
        if(courseObj === undefined || courseObj.episodes === undefined) return {};

        const episodeKeys = Object.keys(courseObj.episodes);

        for (let index = 0; index < episodeKeys.length; index++) {
            const episodeKey = episodeKeys[index];
            const episodeValue = courseObj.episodes[episodeKey];
            if (
                episodeValue !== undefined &&
                episodes[episodeKey] !== undefined
            )
                result[episodeKey] = episodes[episodeKey];
        }
        return result;
    }, [props.courseId, courses, episodes]);

    const episodesArray = useMemo(() => {
        const keys = Object.keys(episodesObj);
        const result: IDBRealtimeEpisode[] = [];

        keys.forEach(key => {
            const episode = episodesObj[key];
            if(episode !== undefined)
                result.push(episode);
        });

        result.sort((a, b) => a.order - b.order);

        return result;
    }, [episodesObj]);

    return { episodes: episodesObj, episodesArray };
}

export { useEpisodes };